import { IUserSantanderOperationLimit } from '../interfaces/user-santander-operation-limit.interface';

export class UserSantanderOperationLimit implements IUserSantanderOperationLimit {
    public accept: boolean;
    public value: number;
    public hasIntegrated: boolean;
    public createAt?: Date;
    public updateAt?: Date;

    constructor({ accept = false, value = 0, hasIntegrated = false, createAt, updateAt }: { accept?: boolean; value?: number; hasIntegrated?: boolean; createAt?: Date; updateAt?: Date }) {
        this.accept = accept;
        this.value = value;
        this.hasIntegrated = hasIntegrated;
        this.createAt = createAt;
        this.updateAt = updateAt;
    }

    /**
     * Cria uma instância do modelo a partir de um objeto JSON
     * @param json - Objeto JSON da API
     * @returns Uma nova instância de UserSantanderOperationLimit
     */
    public static fromJson(json: any): UserSantanderOperationLimit {
        return new UserSantanderOperationLimit(
            {
                accept: json.accept,
                value: json.value,
                hasIntegrated: json.hasIntegrated,
                createAt: json.createAt ? new Date(json.createAt) : null,
                updateAt: json.updateAt ? new Date(json.updateAt) : null,
            }
        );
    }

    public isSantanderCustomer(): boolean {
        return this.hasIntegrated;
    }

    public hasAcceptedTerms(): boolean {
        return this.accept;
    }
}
